var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"mb-5"},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.$t('welcome'))+", "+_vm._s(_vm.$store.state.admin.user.first_name)+"!")])])}
var staticRenderFns = []

export { render, staticRenderFns }